/**
 * Binds one click listener per listing copy button (inside `root`).
 * Re-run after injecting listing HTML (e.g. dialog) so new nodes get handlers.
 */
export function bindListingDetailCopyButtons(root: ParentNode): void {
  const buttons = root.querySelectorAll(
    'button.listing-detail__share-btn[data-copy-url]'
  )
  for (const node of buttons) {
    if (!(node instanceof HTMLButtonElement)) {
      continue
    }
    if (node.dataset.copyBound === 'true') {
      continue
    }
    node.dataset.copyBound = 'true'
    node.addEventListener('click', (event) =>
      handleListingDetailCopyClick(node, event))
  }
}

function handleListingDetailCopyClick(
  element: HTMLButtonElement,
  event: PointerEvent
): void {
  event.preventDefault()

  const url = element.dataset.copyUrl
  if (url) {
    try {
      navigator.clipboard?.writeText(url)

      // Show 'link copied' label
      element.classList.add('listing-detail__share-btn--copied')
      setTimeout(() => {
        element.classList.remove('listing-detail__share-btn--copied')
      }, 2000)
    } catch (error) {
      // Ignore error
    }
  }
}

function bindCopyButtonsOnDocument(): void {
  bindListingDetailCopyButtons(document)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCopyButtonsOnDocument)
  } else {
    bindCopyButtonsOnDocument()
  }
}
